import { Component, EventEmitter, Inject, Input, Output, PLATFORM_ID } from '@angular/core';
import { AgenxButtonComponent } from "../../atoms/button/button.component";
import { OfflineService } from '../../../../services/offline.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AgenxRadioComponent } from "../../atoms/radio/radio.component";
import { FormControl, Validators } from '@angular/forms';
import { AgenxInputComponent } from "../../atoms/input/input.component";
import { Operator, Vehicle } from '../../../../interfaces/create-edit.interface';
import { AgenxCircleButtonComponent } from "../../atoms/circle-button/circle-button.component";
import { AgenxCheckboxComponent } from "../../atoms/checkbox/checkbox.component";
import { ObjectsService } from '../../../../services/objects.service';
import { Subscription } from 'rxjs';
import { ToastService } from '../../../../services/toast.service';

@Component({
  selector: 'app-operators',
  standalone: true,
  imports: [
    AgenxButtonComponent,
    AgenxRadioComponent,
    AgenxInputComponent,
    AgenxCircleButtonComponent,
    AgenxCheckboxComponent,
  ],
  templateUrl: './operators.component.html',
  styleUrl: './operators.component.scss',
})
export class OperatorsComponent {
  private subscriptions: Subscription[] = [];
  @Output() sendResponse = new EventEmitter<Vehicle | null>();
  icon_x_src = '';
  icon_search_src = '';
  driverCtrl = new FormControl('', [Validators.required]);
  search_input = new FormControl('');
  driversList: Array<Operator> = [];
  auxList: Array<Operator> = [];
  operators_selected: Array<number> = [];
  loading: 'loading' | 'normal' = 'normal';
  no_internet = false;
  noSelected = false

  constructor(
    private offlineSrv: OfflineService,
    private objectsSrv: ObjectsService,
    private toastSrv: ToastService,
    @Inject(PLATFORM_ID) private platformId: any,
    public dialogRef: MatDialogRef<OperatorsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  /**
   * Closes the modal dialog and emits the signature image.
   */
  closeModal(vehicle?: Vehicle): void {
    this.dialogRef.close(vehicle);
  }

  /**
   * Initializes the signature pad after the view has been initialized.
   */
  ngAfterViewInit() {
    this.icon_x_src = this.offlineSrv.loadAssetInLocal('Icon_X.svg');
  }

  ngOnInit() {
    let operators = this.data.operators;
    this.driversList = operators.filter((op: Operator) => op.type_id == 1);
    this.auxList = operators.filter((op: Operator) => op.type_id == 2);
  }

  /**
   * Saves the current signature from the pad or loaded file and emits it.
   */
  save() {
    let checkboxes = document.querySelectorAll(
      'input[id^="aux-"]:checked'
    ) as NodeListOf<HTMLInputElement>;
    if (checkboxes.length > 0 || this.driverCtrl.value) {
      this.noSelected = false;
      this.loading = 'loading';
      this.operators_selected = this.driverCtrl.value ?
      [Number(this.driverCtrl.value)] : [];
      checkboxes.forEach((check) => {
        this.operators_selected.push(Number(check.value));
      });
      this.subscriptions.push(
        this.objectsSrv
          .setOperators(
            { operators: this.operators_selected },
            this.data.vehicle_id!
          )
          .subscribe({
            next: (vehicle: Vehicle) => {
              this.loading = 'normal';
              this.closeModal(vehicle);
            },
            error: (error: { error: { detailed: string } }) => {
              this.loading = 'normal';
              this.sendResponse.emit(null);
              this.closeModal();
              let message = error.error.hasOwnProperty('detailed')
                ? error.error.detailed
                : 'No se pudo guardar la información.';
              this.no_internet &&
                (message += ' No cuenta con una conexión estable a internet.');
              this.toastSrv.error(message);
            },
          })
      );
    } else {
      this.noSelected = true;
    }
  }

}
